import { Action as ReduxAction } from 'redux';
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { CompositeSessionInfoSelectors, SessionSiteSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { ICollectionInfo } from '../../Collections/ICollectionInfo';
import { changeCollectionVisibility } from '../../../actions/spaces/Collections/ChangeCollectionVisibilityAction';

export const ChangeCollectionVisibilityAction: IEntityAction<ICollectionInfo, {}> = {
  name: EntityActionNames.ChangeCollectionVisibility,
  translateName: Messages.collectionsChangeVisiblityMenu,
  isVisible: () => {
    return FeatureFlags.collectionsEnabled;
  },
  isClickable: (_availableActions: {}, targetItems: ICollectionInfo[], state: AppState) => {
    if(targetItems.length !== 1) return false;

    const item = targetItems[0];
    const isAdminOrOwner = CompositeSessionInfoSelectors.currentUserIsAdminOrOwnerSelector(item.owner)(state);
    return isAdminOrOwner && SessionSiteSelectors.isPublicCollectionsEnabled(state);
  },
  createReduxAction: (targetItems: ICollectionInfo[]): ReduxAction => {
    return changeCollectionVisibility(targetItems[0]);
  },
};

